"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseResponsiveImage = exports.BaseImage = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _primitives = require("../../platform/primitives");

var _CleanTag = require("../CleanTag");

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ratioPadding = (0, _styledSystem.system)({
  ratio: {
    property: "paddingBottom",
    transform: function transform(n) {
      return n * 100 + "%";
    }
  }
});
/** Props for web & iOS images */

/**
 * Image component with space, width and height properties
 */
var BaseImage = (0, _styledComponents.default)(_CleanTag.CleanTag.as(_primitives.Image)).withConfig({
  displayName: "Imageshared__BaseImage",
  componentId: "sc-1dymtq1-0"
})(["", ";", ";", ";", ""], _styledSystem.space, _styledSystem.width, _styledSystem.height, _styledSystem.borderRadius);
exports.BaseImage = BaseImage;

/**
 * An Image component that responsively resizes within its environment
 */
var BaseResponsiveImage = (0, _styledComponents.default)(_CleanTag.CleanTag).withConfig({
  displayName: "Imageshared__BaseResponsiveImage",
  componentId: "sc-1dymtq1-1"
})(["background:url(", ");background-size:contain;background-repeat:no-repeat;background-position:center;", ";", ";", ";", ";"], function (props) {
  return props.src;
}, _styledSystem.space, _styledSystem.width, _styledSystem.maxWidth, function (props) {
  return props.ratio ? _objectSpread({
    height: 0
  }, ratioPadding(props)) : null;
});
exports.BaseResponsiveImage = BaseResponsiveImage;
BaseResponsiveImage.defaultProps = {
  width: "100%",
  ratio: 1
};
//# sourceMappingURL=Image.shared.js.map